const sideBar = {
	state: {
		showSideBar: false
	},
	mutations: {
		toggleSideBar(state) {
			state.showSideBar = !state.showSideBar;
		},
		closeSideBar(state) {
			state.showSideBar = false;
		}
	},
	getters: {
		getSideBar(state) {
			return state.showSideBar;
		}
	}
}

export default sideBar;